import React, { useEffect, useRef, useState } from 'react'
import qz from "qz-tray";
import { useSelector } from "react-redux";


export default function QzPrinting() {
  const tagOwner = useSelector(state => state.tagOwner);
  const qzCertificate = useSelector(state => state.qz_certificate)
  const qzPrivateKey = useSelector(state => state.qz_private_key)

  const printingEnabled = useSelector(state => state.printing_enabled);
  const printTimestamp = useSelector(state => state.printTimestamp)
  const printSettingId = useSelector(state => state.print_setting_id);
  const printOrientation = useSelector(state => state.print_orientation);
  const printBackside = useSelector(state => state.print_backside);
  const printingUrl = useSelector(state => state.printing_url);

  const [ready, setReady] = useState(false)
  const [printing, setPrinting] = useState(false)

  const printerEventHandling = (e) => {
    if ((event == undefined || event.type != "close") && qz.websocket.isActive()) {
      setReady(true)
    } else {
      setReady(false)
    }
  }

  const connectWithPrinter = () => {
    qz.security.setCertificatePromise((resolve, reject) => {
      resolve(qzCertificate);
    });
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        try {
          let pk = KEYUTIL.getKey(qzPrivateKey);
          let sig = new KJUR.crypto.Signature({ "alg": "SHA1withRSA" });
          sig.init(pk);
          sig.updateString(toSign);
          let hex = sig.sign();
          console.log("DEBUG: \n\n" + stob64(hextorstr(hex)));
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          console.error(err);
          reject(err);
        }
      };
    });

    if (!qz.websocket.isActive()) {
      qz.websocket.connect({ retries: 55555, delay: 2 })
        .then(function () {
          printerEventHandling()
          qz.printers.getDefault()
            .then(function (data) { })
            .catch(function (e) {
              console.error(e);
              alert("Please select a default printer! | No printer found.\n\nError-Message: " + e)
            });
        })
        .catch(function (e) {
          console.error(e);
          alert("printerWebsocketConnect" + e)
        });
    } else {
      console.log("websocket connection", qz.websocket.getConnectionInfo());
    }

    qz.websocket.setClosedCallbacks(printerEventHandling);
    qz.websocket.setErrorCallbacks(printerEventHandling);
  };

  useEffect(() => {
    connectWithPrinter();
  }, [printingEnabled])

  useEffect(() => {
    if (printingEnabled && ready) {
      if (printTimestamp) {
        let url = printingUrl.replace("@id@", tagOwner.id).replace("@printsetting@", printSettingId).replace("&rfid=@rfid@", "");

        qz.printers.getDefault().then(function (printer) {
          setPrinting(true)

          if (printer == null) {
            alert("No default printer found! Please set a default printer.");
            setPrinting(false)
            return;
          }

          let printerConfig = qz.configs.create(printer);;

          // if (checkin.etiquette_printing) {
          //     printerConfig = qz.configs.create(printer, {scaleContent: "false"});
          //     printerConfig.config.size = {
          //         width: printSetting.document_width,
          //         height: printSetting.document_height,
          //         margins: 0
          //     }
          // } else {
          //     printerConfig = qz.configs.create(printer);
          // }
          printerConfig.config.units = 'cm';
          printerConfig.config.jobName = tagOwner.parameterized_name + "_" + (new Date().getTime().toString()) + ".pdf";
          printerConfig.config.duplex = printBackside;
          printerConfig.config.orientation = (printOrientation !== "" ? printOrientation : null) || null;
          printerConfig.config.colorType = "blackwhite";

          let printData = [
            { type: 'pdf', data: url }
          ];

          qz.print(printerConfig, printData).then(function () {
            setPrinting(false)
          }).catch(function (e) {
            console.error(e);
            setPrinting(false);
            alert("An printing error occured.\n\nError: printPDF1" + e)
          });

        }).catch(function (e) {
          console.error(e);
          setPrinting(false);
          alert("No default printer found. Please set a default printer!\n\nError-Message: printPDF2 - " + e)
        });
      }
    }
  }, [ready, printTimestamp]);
  return (<></>)
  // if(!printingEnabled) return (<></>)
  // if(printing) return (<span className="printerBadge badge bg-warning"><i className={"fas fa-spinner fa-spin me-2"}></i>PDF wird gedruckt!</span>)
  // if(ready) return (<span className="printerBadge badge bg-success"><i className="fas fa-print me-2"></i>Printer connected</span>)
  // return (<span className="printerBadge badge bg-danger"><i className="fas fa-print-slash me-2"></i>Printer not connected</span>)
}
